// extracted by mini-css-extract-plugin
export default {"moreButtonMobile":"bcIz4","large":"ItCe2"};